<app-app-banner dismissKey="vm_login_banner_dismissed"></app-app-banner>

<div class="login-layout">
  <!-- LEFT SLIDER -->
  <div class="slider-section">
    <div class="slider">
      <div
        class="slide"
        *ngFor="let slide of slides; let i = index"
        [class.active]="i === activeSlide"
        [class.graphic]="graphicSlides"
        [style.backgroundImage]="graphicSlides ? null : 'url(' + slide.image + ')'"
      >
        <app-login-slide-art *ngIf="graphicSlides" [scene]="$any(i)" [active]="i === activeSlide"></app-login-slide-art>
        <div class="slide-content">
          <h2>{{ slide.title }}</h2>
          <p>{{ slide.subtitle }}</p>
        </div>
      </div>

      <div class="dots">
        <span
          *ngFor="let slide of slides; let i = index"
          [class.active]="i === activeSlide"
          (click)="setSlide(i)"
        ></span>
      </div>
    </div>
  </div>

  <!-- RIGHT PANEL -->
  <div class="login-section">

    <!-- LOGIN FORM -->
    <div class="login-card" *ngIf="view === 'login'">
      <span class="login-heading">Welcome to Vector</span>
      <p class="subtitle">Login to your account</p>

      <div class="form-group email-group">
        <label>Email</label>
        <input
          type="email"
          autocomplete="off"
          placeholder="Enter your email"
          [(ngModel)]="email"
          [class.invalid]="formSubmitted && !email.trim()"
          (focus)="openAccountPicker()"
          (blur)="closeAccountPicker()"
        />
        <!-- Account picker dropdown — appears below email input -->
        <div class="account-picker-dropdown" *ngIf="showAccountPicker && savedAccounts.length > 0">
          <p class="picker-title">Choose Account</p>
          <div class="account-list">
            <div class="account-row" *ngFor="let account of savedAccounts" (mousedown)="selectAccount(account)">
              <div class="account-avatar"><mat-icon>person</mat-icon></div>
              <span class="account-email">{{ account.email }}</span>
              <button class="remove-btn" (mousedown)="removeAccount(account.email, $event)" aria-label="Remove account">
                <mat-icon>remove</mat-icon>
              </button>
            </div>
            <div class="account-row add-row" (mousedown)="addAccount()">
              <div class="account-avatar" [class.at-limit]="savedAccounts.length >= 3"><mat-icon>person_add</mat-icon></div>
              <span class="add-label" [class.at-limit]="savedAccounts.length >= 3">Add account</span>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group password-group">
        <label>Password</label>
        <div class="password-wrapper">
          <input
            [type]="showPassword ? 'text' : 'password'"
            placeholder="Enter your password"
            [(ngModel)]="password"
            [class.invalid]="formSubmitted && !password.trim()"
          />
          <span class="eye-icon" (click)="togglePasswordVisibility()">
            <mat-icon>{{ showPassword ? "visibility_off" : "visibility" }}</mat-icon>
          </span>
        </div>
      </div>

      <div class="row">
        <label class="checkbox">
          <input class="input-box" type="checkbox" [(ngModel)]="rememberMe" />
          <span class="remember-me">Remember me</span>
        </label>
        <a class="link" (click)="openForgotPassword()">Forgot password?</a>
      </div>

      <lib-button
        [variant]="'contained'"
        [size]="'medium'"
        [type]="'primary'"
        [label]="'Login'"
        (click)="login()"
      ></lib-button>

    </div>

    <!-- FORGOT PASSWORD FORM -->
    <div class="login-card" *ngIf="view === 'forgot'">
      <button class="back-btn" (click)="backToLogin()">
        <mat-icon>arrow_back_ios</mat-icon>
      </button>

      <span class="login-heading">Forgot Password?</span>
      <p class="subtitle">Please enter the email address you signed up with to reset your password.</p>

      <div class="form-group">
        <label>Email</label>
        <input
          type="email"
          placeholder="Enter your email"
          [(ngModel)]="forgotEmail"
          [class.invalid]="forgotSubmitted && !forgotEmail.trim()"
        />
      </div>

      <lib-button
        [variant]="'contained'"
        [size]="'medium'"
        [type]="'primary'"
        [label]="forgotLoading ? 'Sending...' : 'Send Email'"
        (click)="submitForgotPassword()"
      ></lib-button>

      <span class="footer forgot-footer" (click)="backToLogin()">
        Back to <a class="footer-link">Login</a>
      </span>
    </div>

  </div>
</div>


<lib-snackbar
  [message]="snackbarMessage"
  [type]="snackbarType"
  [show]="showSnackbar"
  [duration]="4000"
  [autoClose]="true"
  [theme]="'light'"
  (onClose)="onSnackbarClose()"
  (onAutoClose)="onSnackbarAutoClose()"
></lib-snackbar>

<app-loader [loading]="loading"></app-loader>

<!-- Active session dialog -->
<div class="active-session-overlay" *ngIf="showActiveSessionDialog" (click)="showActiveSessionDialog = false">
  <div class="active-session-dialog" (click)="$event.stopPropagation()">
    <div class="dialog-icon">
      <mat-icon>warning_amber</mat-icon>
    </div>
    <h3 class="dialog-title">Active Session Detected</h3>
    <p class="dialog-message">You already have an active session. Please log out from your other device or browser before signing in here.</p>
    <button class="dialog-ok-btn" (click)="showActiveSessionDialog = false">OK</button>
  </div>
</div>
